import request from '@/utils/request'

export function teamworkItems (params) {
  return request({
    url: '/amrep/teamwork/items',
    method: 'get',
    params
  })
}

export function teamworkCreate (data) {
  return request({
    url: '/amrep/teamwork/create',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/teamwork.js